import React from 'react';
import { Control } from 'react-hook-form';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '../Button/Button';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

const useStyles = makeStyles((theme: any) => ({
  button: {
    width: '100%',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    fontSize: 16,
    lineHeight: 1.5,
    border: ({ selected }: any) =>
      '2px solid ' +
      (selected ? theme.palette.brand.greenLight : 'rgba(0,0,0,0.08)'),
    '& .MuiButton-label': {
      justifyContent: 'start',
      textAlign: 'left',
    },
    '& .MuiButton-startIcon': {
      marginBottom: 'auto',
      marginLeft: 0,
      marginRight: theme.spacing(2),
    },
  },
  radioIconSelected: {
    color: theme.palette.brand.greenLight,
  },
  radioIcon: {
    height: theme.spacing(4),
    width: theme.spacing(4),
    marginRight: ({ flexDirection }: { flexDirection: string }) => {
      if (flexDirection === 'row') {
        return theme.spacing(2);
      } else {
        return 0;
      }
    },
  },
  buttonContent: {
    display: 'flex',
    flexDirection: ({ flexDirection }: { flexDirection: any }) => flexDirection,
    alignItems: 'center',
  },
}));

interface RadioButtonProps {
  id: string;
  name: string;
  text?: string | React.ReactNode;
  tooltipText?: string;
  setValue: (id: string, name: string) => void;
  useWatch: ({ control: Control, name: string }) => any;
  control: Control;
  setSelected?: (selected) => void;
  flexDirection?: string;
  dataAutomationId?: string;
}

export default function RadioButton({
  id,
  name,
  text,
  tooltipText = null,
  setValue,
  useWatch,
  control,
  flexDirection,
  dataAutomationId,
}: RadioButtonProps) {
  const selectedOption = useWatch({ control, name: id });
  const selected = selectedOption === name;
  const classes = useStyles({ selected, flexDirection });

  function handleClick(event) {
    event.preventDefault();
    setValue(id, name);
  }

  return (
    <Button
      className={classes.button}
      variant="outlined"
      tooltipText={tooltipText}
      onClick={handleClick}
      data-automation-id={dataAutomationId}
    >
      <div className={classes.buttonContent}>
        {selected ? (
          <RadioButtonCheckedIcon
            className={`${classes.radioIconSelected} ${classes.radioIcon}`}
          />
        ) : (
          <RadioButtonUncheckedIcon className={classes.radioIcon} />
        )}
        {text}
      </div>
    </Button>
  );
}
